import { render, staticRenderFns } from "./addBooking.vue?vue&type=template&id=578ede91&scoped=true&"
import script from "./addBooking.vue?vue&type=script&lang=js&"
export * from "./addBooking.vue?vue&type=script&lang=js&"
import style0 from "./addBooking.vue?vue&type=style&index=0&id=578ede91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578ede91",
  null
  
)

export default component.exports